import riot from 'riot';
import events from '../src/events.js';
import { getActivityTelemetry as libGetActivityTelemetry, deleteActivityTelemetry as libDeleteActivityTelemetry, postDirectMethod as libPostDirectMethod, getMonitors as libGetMonitors, getSmartkits as libGetSmartkits, postMonitor as libPostMonitor, deleteMonitor as libDeleteMonitor, putProgress as libPutProgress } from '../src/lib.js';
riot.tag2('activity-details', '<nav class="navbar" role="navigation" aria-label="main navigation" style="background-color: rgb(245,245,245); border-bottom: 1px solid #dbdbdb;"> <div class="navbar-brand"> <span class="navbar-item"> <span class="icon has-text-success" style="margin-right: 0.4rem;"><i class="fas fa-bolt"></i></span> <span class="has-text-weight-semibold">{selectedActivity && selectedActivity.lesson ? selectedActivity.lesson.name : \'Activity\'}</span> </span> </div> <div class="navbar-menu is-active"> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-info" onclick="{toggleMeasurements}"> <span class="icon is-small"><i class="fas fa-balance-scale"></i></span> <span>{showMeasurements ? \'Back to Lesson\' : \'All Measurements\'}</span> </button> <button class="button is-danger" if="{!showMeasurements}" onclick="{exitDetailsClick}"> <span class="icon is-small"><i class="fas fa-times"></i></span> <span>Save &amp; Close</span> </button> </div> </div> </div> </div> </nav> <measurements show="{showMeasurements}"></measurements> <div class="box" show="{!showMeasurements}"> <nav class="pagination is-centered is-small" role="navigation" aria-label="pagination" if="{selectedActivity && selectedActivity.lesson.steps[0].type !=\'gslides\'}"> <a class="pagination-previous" onclick="{prevStep}"> <span class="icon"> <i class="fas fa-arrow-left"></i> </span> </a> <a class="pagination-next" onclick="{nextStep}"> <span class="icon"> <i class="fas fa-arrow-right"></i> </span> </a> <ul class="pagination-list"> <li each="{tab,i in selectedActivity.lesson.steps}" class="tab" onclick="{parent.toggleTab}"> <a class="pagination-link {is-info-edjro: parent.isActiveTab(i)} {is-current: parent.isActiveTab(i)}"> <span>{tab.title}</span> </a> </li> </ul> </nav> </div> <div class="card" show="{!showMeasurements}"> <header class="card-header"> <p class="card-header-title"> {activeStep && activeStep.title} </p> </header> <div class="card-content"> <div class="content" if="{activeStep && activeStep.type===\'supplies\'}"> <div class="step-instructions"> <div class="instructions-header"> <h3 class="title is-4">Step Instructions</h3> </div> <div class="steps-container"> <div each="{t,i in prettyDirections(activeStep.directions)}" if="{t}" class="step-item"> <div class="step-marker"> <span class="step-number">{i+1}</span> </div> <div class="step-content"> <p class="step-text">{t}</p> </div> </div> </div> </div> <activity-supplies></activity-supplies> </div> <div class="content" if="{activeStep && activeStep.type===\'gslides\'}"> <div class="step-instructions"> <div class="instructions-header"> <h3 class="title is-4">Step Instructions</h3> </div> <div class="steps-container"> <div each="{t,i in prettyDirections(activeStep.directions)}" if="{t}" class="step-item"> <div class="step-marker"> <span class="step-number">{i+1}</span> </div> <div class="step-content"> <p class="step-text">{t}</p> </div> </div> </div> </div> <div class="content"> <iframe riot-src="{activeStep.link}" frameborder="0" width="100%" height="600" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe> </div> </div> <div if="{activeStep && (activeStep.type===\'task\' || activeStep.type===\'setup\')}"> <div class="columns" if="{activeStep && activeStep.image}"> <div class="column is-8"> <div class="step-instructions"> <div class="instructions-header"> <h3 class="title is-4">Step Instructions</h3> </div> <div class="steps-container"> <div each="{t,i in prettyDirections(activeStep.directions)}" if="{t}" class="step-item"> <div class="step-marker"> <span class="step-number">{i+1}</span> </div> <div class="step-content"> <p class="step-text">{t}</p> </div> </div> </div> </div> </div> <div class="column is-4"> <div class="step-instructions"> <div class="instructions-header"> <h3 class="title is-4">{activeStep.imageTitle?activeStep.imageTitle:⁗Step Image⁗}</h3> </div> <div class="steps-container"> <figure class="image"> <img riot-src="img/{activeStep.image}" alt="{activeStep.title} Image" style="border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"> </figure> </div> </div> </div> </div> <div if="{activeStep && !activeStep.image}"> <div class="step-instructions"> <div class="instructions-header"> <h3 class="title is-4">Step Instructions</h3> </div> <div class="steps-container"> <div each="{t,i in prettyDirections(activeStep.directions)}" if="{t}" class="step-item"> <div class="step-marker"> <span class="step-number">{i+1}</span> </div> <div class="step-content"> <p class="step-text">{t}</p> </div> </div> </div> </div> </div> <div class="columns is-variable" if="{activeStep && activeStep.type===\'task\'}" style="margin-bottom: 5px;"> <div class="column is-5"> <article class="message"> <div class="message-header"> <p if="{showSensorDetails && selectedSensor}">Sensor Info ({selectedSensor.display_name})</p> <p if="{!showSensorDetails}">Measurements</p> </div> <div class="message-body" if="{activeStep && activeStep.sensor != \'test\'}"> <div class="buttons"> <button class="button is-primary is-fullwidth" onclick="{toggleSensorDetails}">{showSensorDetails?\'Hide\':\'Show\'} Sensor Details</button> </div> </div> <div class="message-body" if="{showSensorDetails && activeStep && activeStep.sensor != \'test\' && selectedSensor}"> <sensor sensor="{selectedSensor}" device="{selectedFullDevice}" deviceid="{selectedDeviceId}"></sensor> </div> <div class="message-body" if="{!showSensorDetails}"> <div class="container is-fluid" show="{telemetryLoading}" style="margin-top: 5px; margin-bottom:5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <article class="message is-dark" if="{stepHasMonitors}"> <div class="message-body is-info-edjro"> Automatic measurements are scheduled <b>{stepMonitor.period}</b>. You can cancel them below. </div> </article> <div class="box" if="{telemetryLoading==false && !telemetryError}"> <div class="table-container"> <table class="table is-fullwidth is-striped is-hoverable"> <thead> <tr> <th>Timestamp</th> <th>Message</th> <th>Value</th> <th>Unit</th> <th>Action</th> </tr> </thead> <tbody> <tr each="{row,i in getPaginatedTelemetryRows()}"> <td>{epochToHumanDate(row.ts)}</td> <td> <span>{row.msg}</span> </td> <td> <span>{prettyValue(row.value)}</span> </td> <td> <span>{row.unit}</span> </td> <td> <button class="button is-danger" onclick="{deleteTelemetryClick}"> <span class="icon"><i class="far fa-trash-alt"></i></span> </button> </td> </tr> </tbody> </table> </div> <nav class="pagination is-centered is-small is-rounded" role="navigation" aria-label="pagination"> <a class="pagination-previous" onclick="{prevPage}">Previous</a> <a class="pagination-next" onclick="{nextPage}">Next</a> <ul class="pagination-list"> <li><a class="pagination-link">{currentPage}</a></li> </ul> </nav> </div> <article class="message is-danger" if="{telemetryError}"> <div class="message-header"> <p>Oh No!</p> </div> <div class="message-body"> It looks like there was an error loading the past measurement! <button class="button is-warning" onclick="{refreshTelemetryClick}">Refresh!</button> </div> </article> <article class="message is-danger" if="{measureError}"> <div class="message-header"> <p>Oh No!</p> </div> <div class="message-body"> It looks like there was an error taking the measurement! Please try again. </div> </article> <div class="field is-grouped is-grouped-multiline"> <div class="control" if="{smartkitsLoading}"> <button class="button is-info is-loading" disabled>Loading device...</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && !measureError}"> <button class="button is-success" onclick="{measureClick}" title="Take a single measurement from the sensor right now">Measure Now</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && !measureError && !monitorLoading && !stepHasMonitors}"> <button class="button is-success" onclick="{hourlyMonitorClick}" title="Schedule an automatic measurement every hour until cancelled">Measure Hourly</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && !measureError && !monitorLoading && !stepHasMonitors}"> <button class="button is-success" onclick="{dailyMonitorClick}" title="Schedule an automatic measurement once per day until cancelled">Measure Daily</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && !measureError && !monitorLoading && !stepHasMonitors}"> <button class="button is-info" onclick="{burstMonitorClick}" title="Take a measurement once per minute for 10 minutes, then stop automatically">Measure Burst</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && !measureError && !monitorLoading && stepHasMonitors}"> <button class="button is-danger" onclick="{cancelMonitorClick}" title="Stop all scheduled measurements for this step">Cancel Scheduled</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && monitorLoading}"> <button class="button is-success is-loading">Monitors Loading</button> </div> <div class="control" if="{!smartkitsLoading && !measurementLoading && !telemetryLoading && measureError}"> <button class="button is-warning" onclick="{measureClick}">Try Measurement Again!</button> </div> <div class="container" if="{measurementLoading}"> <button class="button is-success is-loading">Taking Measurement ...</button> </div> </div> </div> </article> </div> <div class="column is-7"> <article class="message"> <div class="message-header"> <p>Charts</p> </div> <div class="message-body"> <div class="notification is-warning is-light" if="{chartTypes.length===0}"> Take some measurements to view data on the charts! </div> <div class="card" each="{c in chartTypes}" style="margin-top: 5px;"> <header class="card-header"> <p class="card-header-title"> {c.charAt(0).toUpperCase() + c.slice(1)} Chart </p> </header> <div class="card-content"> <div class="content"> <canvas id="stepChart_{c}"></canvas> </div> </div> </div> </div> </article> </div> </div> </div> <div class="content" if="{activeStep && activeStep.type===\'quiz\'}"> <knowledge-check activestep="{activeStep}" activestepindex="{activeStepIndex}" selectedactivity="{selectedActivity}"></knowledge-check> </div> </div> <footer class="card-footer" if="{activeStep}"> <a class="card-footer-item" onclick="{prevStep}"><span class="subtitle"><span class="icon is-small"> <i class="fas fa-arrow-left"></i> </span>&nbsp;Previous Step</span></a> <a class="card-footer-item" onclick="{exitDetailsClick}"><span class="subtitle"><span class="icon is-small"> <i class="far fa-save"></i> </span>&nbsp;Save And Close</span></a> <a class="card-footer-item" onclick="{nextStep}"><span class="subtitle">{isLastStep() ? \'Finish Lesson\':\'Next Step\'}&nbsp;<span class="icon is-small"> <i class="fas fa-arrow-right"></i> </span></span></a> </footer> </div>', 'activity-details .step-instructions,[data-is="activity-details"] .step-instructions{ background: #f8f9fa; border-radius: 8px; padding: 1.25rem; margin-bottom: 1.5rem; border-left: 4px solid #3273dc; border: 1px solid #e9ecef; } activity-details .steps-container,[data-is="activity-details"] .steps-container{ margin-top: 1rem; } activity-details .step-item,[data-is="activity-details"] .step-item{ display: flex; align-items: center; margin-bottom: 0.75rem; padding: 0.75rem; background: white; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); transition: all 0.2s ease; } activity-details .step-item:hover,[data-is="activity-details"] .step-item:hover{ box-shadow: 0 2px 4px rgba(0,0,0,0.1); background: #fafbfc; } activity-details .step-item:last-child,[data-is="activity-details"] .step-item:last-child{ margin-bottom: 0; } activity-details .step-marker,[data-is="activity-details"] .step-marker{ flex-shrink: 0; width: 28px; height: 28px; background: #3273dc; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 0.75rem; } activity-details .step-number,[data-is="activity-details"] .step-number{ color: white; font-weight: 600; font-size: 0.875rem; } activity-details .step-content,[data-is="activity-details"] .step-content{ flex: 1; } activity-details .step-text,[data-is="activity-details"] .step-text{ font-size: 1rem; line-height: 1.4; margin: 0; color: #4a4a4a; } activity-details .instructions-header,[data-is="activity-details"] .instructions-header{ display: flex; align-items: center; margin-bottom: 0.75rem; } activity-details .instructions-header .title,[data-is="activity-details"] .instructions-header .title{ margin-bottom: 0 !important; font-size: 1.125rem; } activity-details .instructions-icon,[data-is="activity-details"] .instructions-icon{ margin-right: 0.5rem; color: #3273dc; }', '', function(opts) {
        var self = this;
        self.activeTab = 0;

        self.activeStep = undefined;
        self.selectedActivity = undefined;
        self.activeStepIndex = 0;
        self.measurements = [];
        self.measureError = undefined;
        self.measurementLoading = false;
        self.selectedActivityProgress = undefined;
        self.telemetry = [];
        self.telemetryLoading = false;
        self.telemetryError = undefined;
        self.stepTelemetry = [];
        self.showMeasurements = false;
        self.selectedDeviceId = undefined;
        self.selectedFullDevice = undefined;
        self.selectedSensor = undefined;
        self.monitors = [];
        self.stepHasMonitors = false;
        self.stepMonitor = undefined;
        self.monitorLoading = false;
        self.configuringMonitor = false;
        self.smartkitsLoading = false;
        self.chartTypes = [];
        self.charts = [];
        self.currentPage = 1;
        self.itemsPerPage = 10;
        self.showSensorDetails = false;

        events.on('select_activity_details', function(evtData) {
            const { selectedActivity, progress_data, selectedDeviceId, targetStep } = evtData;

            if (self.parent.user && self.parent.user.progress && selectedActivity) {
                var foundProgress = false;
                for (var i = 0; i < self.parent.user.progress.length; i++) {
                    if (self.parent.user.progress[i].activity_ref == selectedActivity.activity_ref) {
                        foundProgress = true;

                        if (targetStep !== undefined) {
                            console.log("Using target step from URL:", targetStep);
                            self.activeStepIndex = targetStep;
                        } else {
                            self.activeStepIndex = self.parent.user.progress[i].step;
                        }

                        self.activeStep = selectedActivity.lesson.steps[self.activeStepIndex];
                        self.activeTab = self.activeStepIndex;
                        self.selectedActivity = selectedActivity;
                        self.selectedActivityProgress = { activity_ref: selectedActivity.activity_ref, device: selectedDeviceId };
                        self.setSelectedSensor();

                        self.updateStepURL();
                        break;
                    }
                }

                if (!foundProgress) {
                    self.activeStepIndex = targetStep !== undefined ? targetStep : 0;
                    self.activeStep = selectedActivity.lesson.steps[self.activeStepIndex];
                    self.activeTab = self.activeStepIndex;
                    self.selectedActivity = selectedActivity;
                    self.selectedActivityProgress = progress_data || { activity_ref: selectedActivity.activity_ref, device: selectedDeviceId };
                    self.setSelectedSensor();
                    self.updateStepURL();
                }

                self.selectedDeviceId = selectedDeviceId;

                self.charts.forEach(c => c.destroy());

                if (self.selectedActivityProgress && self.selectedActivityProgress.activity_ref) {
                    getActivityTelemetry(selectedDeviceId, self.selectedActivityProgress.activity_ref);
                }

                getMonitors();
            } else {
                console.log("[FATAL] No user progress was found or selectedActivity is undefined")
            }

            getSmartkits()

            if (self.activeStep && self.activeStep.type == 'quiz') {
                console.log("Loading quiz responses for step " + self.activeStepIndex);
                events.emit("get_quiz_responses", {
                    "activeStepIndex": self.activeStepIndex,
                    "activeStep": self.activeStep,
                    "act_ref": selectedActivity.activity_ref,
                    "load_responses": true
                });
            }
            self.update();

        });

        events.on('measurement_complete', function() {

            getActivityTelemetry(self.selectedActivityProgress.device, self.selectedActivityProgress.activity_ref);

            self.measurements = [];
            self.measureError = undefined;

        });

        events.on('telemetry_loaded', function(telemetry_data) {

            self.stepTelemetry = telemetry_data.filter(t => t.activity_step == self.activeStepIndex);

            self.stepTelemetry.sort((a, b) => (a._ts < b._ts) ? 1 : -1);

            self.update({
                telemetryLoading: false,
                telemetry: telemetry_data,
                telemetryError: undefined,
                currentPage: 1
            });

            try {
                self.buildCharts();
            } catch (error) {
                console.error("Error Building Charts: " + error)
            }
        });

        events.on('activity_step_changed', function(stepIndex) {

            self.stepTelemetry = self.telemetry.filter(t => t.activity_step == stepIndex);
            self.currentPage = 1;
            self.update();

            try {
                self.buildCharts();
            } catch (error) {
                console.error("Error Building Charts: " + error)
            }
            self.checkStepHasMonitors();
        });

        this.getPaginatedTelemetry = function() {
            const start = (self.currentPage - 1) * self.itemsPerPage;
            const end = start + self.itemsPerPage;
            pagedTelemetry = self.stepTelemetry.slice(start, end);
            return pagedTelemetry;
        }

        this.getPaginatedTelemetryRows = function() {
            const paginatedTelemetry = self.getPaginatedTelemetry();
            const rows = [];

            paginatedTelemetry.forEach(t => {
                if (t.data) {
                    t.data.forEach(d => {
                        rows.push({
                            msg: d.msg ? d.msg : d.type,
                            value: d.value,
                            unit: d.unit,
                            ts: t._ts,
                            telemetry: t
                        });
                    });
                }
            });

            return rows;
        }

        this.nextPage = function() {
            if (self.currentPage * self.itemsPerPage < self.stepTelemetry.length) {
                self.currentPage++;
                self.update();
            }
        }

        this.prevPage = function() {
            if (self.currentPage > 1) {
                self.currentPage--;
                self.update();
            }
        }

        this.buildCharts = function() {

            if (self.charts) {
                self.charts.forEach(c => {
                    try {
                        c.destroy();
                    } catch (error) {
                        console.warn("Error destroying chart:", error);
                    }
                });
                self.charts = [];
            }

            if (self.chartTypes && self.chartTypes.length > 0) {
                self.chartTypes.forEach(chartType => {
                    var canvasId = 'stepChart_' + chartType;
                    var existingChart = Chart.getChart(canvasId);
                    if (existingChart) {
                        try {
                            existingChart.destroy();
                        } catch (error) {
                            console.warn("Error destroying existing chart for canvas " + canvasId + ":", error);
                        }
                    }
                });
            }

            self.chartTypes = [];
            for (var i = 0; i < self.telemetry.length; i++) {
                if (!self.telemetry[i] || !self.telemetry[i].data) continue;
                self.telemetry[i].data.forEach(d => {

                    if (self.telemetry[i].activity_step != self.activeStepIndex) return;

                    if (isNaN(d.value) || typeof d.value === 'boolean') return;
                    if (self.chartTypes.includes(d.type) == false) {
                        self.chartTypes.push(d.type)
                    }
                });
            }

            self.update();

            for (var i = 0; i < self.chartTypes.length; i++) {
                var cLabels = []
                var cDatasets = []
                for (var j = 0; j < self.telemetry.length; j++) {
                    if (!self.telemetry[j] || !self.telemetry[j].data) continue;
                    self.telemetry[j].data.forEach(d => {

                        if (self.telemetry[j].activity_step != self.activeStepIndex) return;

                        if (d.type != self.chartTypes[i]) return;
                        cLabels.push(self.epochToHumanDate(self.telemetry[j]._ts));
                        if (!cDatasets.find(ds => ds.label == (d.type + " (" + d.unit + ")"))) {
                            cDatasets.push({
                                label: d.type + " (" + d.unit + ")",
                                data: [d.value],
                                fill: false,
                                borderColor: randomColor(),
                                tension: 0.1
                            });
                        } else {
                            cDatasets.find(ds => ds.label == (d.type + " (" + d.unit + ")")).data.push(d.value);
                        }
                    });
                }

                var canvasId = 'stepChart_' + self.chartTypes[i];
                var ctx = document.getElementById(canvasId);

                if (!ctx) {
                    console.warn("Canvas element not found for ID:", canvasId);
                    continue;
                }

                var existingChart = Chart.getChart(canvasId);
                if (existingChart) {
                    try {
                        existingChart.destroy();
                    } catch (error) {
                        console.warn("Error destroying existing chart before creation:", error);
                    }
                }

                try {

                    var myChart = new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: cLabels,
                            datasets: cDatasets
                        }
                    });

                    self.charts.push(myChart);
                } catch (error) {
                    console.error("Error creating chart for canvas " + canvasId + ":", error);
                }
            }

            self.update();
        }

        this.epochToHumanDate = function(epoch) {
            var d = new Date(0);
            d.setUTCSeconds(epoch);

            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        }

        this.prettyTimestamp = function(epoch_ms) {

            return new Date(epoch_ms).toLocaleString();
        }

        function randomColor() {
            return 'rgb(' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ')';
        }

        this.checkStepHasMonitors = function() {

            self.stepHasMonitors = false;
            for (var i = 0; i < self.monitors.length; i++) {

                if (self.monitors[i].activity_step == self.activeStepIndex && self.monitors[i].activity_ref == self.selectedActivityProgress.activity_ref && self.monitors[i].device_id == self.selectedActivityProgress.device) {
                    self.stepHasMonitors = true;
                    self.stepMonitor = self.monitors[i];
                }
            }
            if (!self.stepHasMonitors) {
                self.stepMonitor = undefined;
            }
            self.update();
        }

        this.refreshTelemetryClick = function(e) {
            getActivityTelemetry(self.selectedActivityProgress.device, self.selectedActivityProgress.activity_ref);
            getMonitors();
        }

        this.toggleSensorDetails = function(e) {
            self.showSensorDetails = !self.showSensorDetails;
            self.update();
        }

        this.toggleMeasurements = function(e) {
            self.showMeasurements = !self.showMeasurements;

            self.update();
        }

        this.setSelectedSensor = function() {
            self.selectedSensor = undefined;
            if (self.activeStep && self.activeStep.type == 'task') {
                var sensors = JSON.parse(localStorage.getItem("sensors"));
                if (sensors) {
                    for (var i = 0; i < sensors.length; i++) {
                        if (sensors[i].name == self.activeStep.sensor) {
                            self.selectedSensor = sensors[i];
                            break;
                        }
                    }
                } else {
                    console.log("Sensors not loaded yet, waiting for sensors_loaded event");
                }
            }
        }

        this.prettyDirections = function(directions) {
            if (typeof directions == "string") {

                var splits = directions.split(/([.!?])/);

                var result = [];
                for (var i = 0; i < splits.length; i += 2) {
                    if (splits[i] && splits[i].trim()) {
                        var sentence = splits[i];
                        if (splits[i + 1]) {
                            sentence += splits[i + 1];
                        }
                        result.push(sentence.trim());
                    }
                }
                return result;
            } else {

                return directions
            }
        }

        this.exitDetailsClick = function(e) {
            self.parent.unselectActivity()
        }

        this.updateStepURL = function() {
            var actRef = (self.selectedActivity && self.selectedActivity.activity_ref) ||
                         (self.parent.selectedActivity && self.parent.selectedActivity.activity_ref);
            var deviceId = self.selectedDeviceId ||
                           (self.selectedActivityProgress && self.selectedActivityProgress.device);
            if (actRef && deviceId) {
                const params = {
                    device: deviceId
                };

                if (self.activeStepIndex > 0) {
                    params.step = self.activeStepIndex;
                }

                routerHelpers.syncURL('activities', actRef, 'details', params);
            }
        }

        this.isActiveTab = function(tabIndex) {
            return self.activeTab === tabIndex;
        }

        this.toggleTab = function(e) {

            self.activeStep = e.item.tab;
            self.activeStepIndex = e.item.i;
            self.activeTab = self.activeStepIndex;

            self.measurements = [];
            self.measureError = undefined;

            putProgress({
                "progress": {
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "step": self.activeStepIndex,
                    "device": self.selectedDeviceId
                }
            });
            self.setSelectedSensor();

            self.updateStepURL();

            self.update();

            events.emit("activity_step_changed", self.activeStepIndex);

            return true;
        }

        this.isLastStep = function() {
            if (self.activeStepIndex == self.parent.selectedActivity.lesson.steps.length - 1) {
                return true
            } else {
                return false;
            }
        }

        this.nextStep = function() {

            if (self.isLastStep()) {

                self.parent.unselectActivity()
                return
            } else {
                self.activeStepIndex = self.activeStepIndex + 1;
                self.activeStep = self.parent.selectedActivity.lesson.steps[self.activeStepIndex]
                self.activeTab = self.activeStepIndex
            }

            self.measurements = [];
            self.measureError = undefined;

            putProgress({
                "progress": {
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "step": self.activeStepIndex,
                    "device": self.selectedDeviceId
                }
            });
            self.setSelectedSensor();

            self.updateStepURL();

            self.update();

            events.emit("activity_step_changed", self.activeStepIndex);

            if (self.activeStep.type == 'quiz') {
                events.emit("get_quiz_responses", {
                    "activeStepIndex": self.activeStepIndex,
                    "activeStep": self.activeStep,
                    "act_ref": self.parent.selectedActivity.activity_ref,
                    "load_responses": false
                });
            }
        }

        this.prevStep = function() {

            if (self.activeStepIndex == 0) {
                return
            } else {
                self.activeStepIndex = self.activeStepIndex - 1;
                self.activeStep = self.parent.selectedActivity.lesson.steps[self.activeStepIndex]
                self.activeTab = self.activeStepIndex
            }

            self.measurements = [];
            self.measureError = undefined;

            putProgress({
                "progress": {
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "step": self.activeStepIndex,
                    "device": self.selectedDeviceId
                }
            });
            self.setSelectedSensor();

            self.updateStepURL();

            self.update();

            events.emit("activity_step_changed", self.activeStepIndex);

            if (self.activeStep.type == 'quiz') {
                events.emit("get_quiz_responses", {
                    "activeStepIndex": self.activeStepIndex,
                    "activeStep": self.activeStep,
                    "act_ref": self.parent.selectedActivity.activity_ref,
                    "load_responses": false
                });
            }
        }

        this.sensorInfoClick = function(e) {

            if (self.selectedSensor) {
                self.selectedSensor = undefined;
            } else {
                self.selectedSensor = self.activeStep.sensor
            }
            self.update();
        }

        this.measureClick = function(e) {

            try {
                var data = {
                    "device": self.selectedActivityProgress.device,
                    "method": self.activeStep.sensor,
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "activity_step": self.activeStepIndex,
                    "measureType": self.activeStep.measureType ? self.activeStep.measureType : "immediate"
                }
            } catch (error) {
                console.error("Error creating data for measureClick: ", error);
                return;
            }

            postDirectMethod(data)

        }

        this.hourlyMonitorClick = function(e) {
            if (!self.stepHasMonitors) {
                var data = {
                    "device_id": self.selectedActivityProgress.device,
                    "method": self.activeStep.sensor,
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "activity_step": self.activeStepIndex,
                    "period": "hourly"
                }
                postMonitor(data)
            }
        }

        this.dailyMonitorClick = function(e) {
            if (!self.stepHasMonitors) {
                var data = {
                    "device_id": self.selectedActivityProgress.device,
                    "method": self.activeStep.sensor,
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "activity_step": self.activeStepIndex,
                    "period": "daily"
                }
                postMonitor(data)
            }
        }

        this.burstMonitorClick = function(e) {
            if (!self.stepHasMonitors) {
                var data = {
                    "device_id": self.selectedActivityProgress.device,
                    "method": self.activeStep.sensor,
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "activity_step": self.activeStepIndex,
                    "period": "burst",
                    "burst_duration_minutes": 10
                }
                postMonitor(data)
            }
        }

        this.cancelMonitorClick = function(e) {
            if (self.stepHasMonitors) {

                for (var i = 0; i < self.monitors.length; i++) {
                    if (self.monitors[i].activity_step == self.activeStepIndex && self.monitors[i].activity_ref == self.selectedActivityProgress.activity_ref && self.monitors[i].device_id == self.selectedActivityProgress.device) {

                        var data = {
                            "id": self.monitors[i].id,
                        }
                        deleteMonitor(data)
                    }
                }
            }
        }

        this.deleteTelemetryClick = function(e) {
            if (!e || !e.item || !e.item.row || !e.item.row.telemetry) {
                console.error('Invalid telemetry item for deletion');
                return;
            }
            deleteActivityTelemetry(e.item.row.telemetry.id, self.selectedActivityProgress.activity_ref)
        }

        this.prettyValue = function(v) {

            if (v === 0) {
                return 0;
            } else if (!isNaN(v)) {

                try {
                    var rounded = v.toFixed(2);
                    return rounded;
                } catch (e) {
                    return v;
                }
            } else {
                return v
            }
        }

        function getActivityTelemetry(device, act_ref) {

            if (self.telemetryLoading) {
                console.log("Telemetry already loading, skipping duplicate call");
                return;
            }
            self.telemetryLoading = true;
            self.update();
            libGetActivityTelemetry(device, act_ref).then(function(res) {
                if (!res) {
                    throw new Error('No response received');
                }
                if (!res.data) {
                    throw new Error('Response missing data property');
                }
                if (!res.data.telemetry) {

                    events.emit("telemetry_loaded", []);
                    return;
                }
                events.emit("telemetry_loaded", res.data.telemetry);
            }).catch(function(error) {
                console.error('GET Telemetry Error:', error);
                self.update({
                    telemetry: [],
                    telemetryLoading: false,
                    telemetryError: error.message || error
                });
            });
        }

        function deleteActivityTelemetry(id, act_ref) {
            self.telemetryLoading = true;
            self.update();
            libDeleteActivityTelemetry(id, act_ref).then(function(res) {
                self.telemetryLoading = false;
                getActivityTelemetry(self.selectedActivityProgress.device, self.selectedActivityProgress.activity_ref);
            }).catch(function(error) {
                console.error('DELETE Telemetry Error:' + error);
                self.telemetryLoading = false;
                self.update({
                    telemetry: [],
                    telemetryError: error
                });
            });

        }

        function postDirectMethod(data) {
            self.measurementLoading = true;
            self.update();

            libPostDirectMethod(data).then(function(res) {
                self.measurementLoading = false;
                self.update({
                    measurements: res['data'],
                    measureError: undefined
                });
                events.emit("measurement_complete");
            }).catch(function(error) {
                self.measurementLoading = false;
                self.update({
                    measureError: "Measurement " + error
                });
            });
        }

        function getMonitors() {

            if (self.monitorLoading) {
                console.log("Monitors already loading, skipping duplicate call");
                return;
            }
            self.monitorLoading = true;
            self.update();
            libGetMonitors(self.parent.selectedActivity.activity_ref, self.selectedActivityProgress.device).then(function(res) {
                self.monitorLoading = false;
                self.update({
                    monitors: res['data']['monitors'],
                    monitorError: undefined
                });
                self.checkStepHasMonitors();
            }).catch(function(error) {
                console.error('GET Monitors Error:' + error);
                self.monitorLoading = false;
                self.update({
                    monitors: [],
                    stepHasMonitors: false,
                    monitorError: error
                });
            });
        }

        function getSmartkits() {

            if (self.smartkitsLoading) {
                console.log("Smartkits already loading, skipping duplicate call");
                return;
            }
            self.smartkitsLoading = true;
            libGetSmartkits(self.selectedActivityProgress.device).then(function(res) {
                self.smartkitsLoading = false;
                self.update({
                    selectedFullDevice: res['data']['devices'][0]
                });
            }).catch(function(error) {
                console.error('Smartkits Error:' + error);
                self.smartkitsLoading = false;
                self.update({
                    selectedFullDevice: undefined
                });
            });
        }

        function postMonitor(data) {
            self.monitorLoading = true;
            self.update();

            libPostMonitor(data).then(function(res) {
                self.monitorLoading = false;
                getMonitors();
            }).catch(function(error) {
                self.monitorLoading = false;
                self.update({
                    monitorError: "Monitor " + error
                });
            });
        }

        function deleteMonitor(data) {
            self.monitorLoading = true;
            self.update();
            libDeleteMonitor(data).then(function(res) {
                getMonitors();
            }).catch(function(error) {
                console.error('DELETE Monitor Error:' + error);
                self.monitorLoading = false;
                self.update({
                    monitors: [],
                    monitorError: error
                });
            });
        }

        function putProgress(data) {

            if (self.parent.user && self.parent.user.progress && data.progress) {
                var idx = self.parent.user.progress.findIndex(function(p) { return p.activity_ref === data.progress.activity_ref; });
                if (idx >= 0) {
                    self.parent.user.progress[idx] = data.progress;
                } else {
                    self.parent.user.progress.push(data.progress);
                }
                localStorage.setItem("profile", JSON.stringify(self.parent.user));
            }

            libPutProgress(data).then(function(res) {
                events.emit('progress_updated');
            }).catch(function(error) {
                console.error('POST User Error:' + error);
                self.update({
                    error: error
                });
            });

        }

        this.on('unmount', function() {
            if (self.charts && self.charts.length > 0) {
                console.log("Cleaning up charts on component unmount");
                self.charts.forEach(c => {
                    try {
                        c.destroy();
                    } catch (error) {
                        console.warn("Error destroying chart on unmount:", error);
                    }
                });
                self.charts = [];
            }

            events.off('select_activity_details');
            events.off('measurement_complete');
            events.off('activity_ended');
            events.off('telemetry_loaded');
            events.off('activity_step_changed');
            events.off('sensors_loaded');
            events.off('sensor_refresh');
        });
});
